/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Help from '@/views/Help'
import Login from '@/views/Login'
import Search from '@/views/Search'
import Categories from '@/views/Categories'
import BrandingAndLogos from '@/views/BrandingAndLogos'
import PresentationMaterials from '@/views/PresentationMaterials'
import Advertisements from '@/views/Advertisements'
import SellSheetCategories from '@/views/SellSheetCategories'
import SellSheets from '@/views/SellSheets'
import PublicRelations from '@/views/PublicRelations'
import Videos from '@/views/Videos'
import C1868Categories from '@/views/C1868Categories'
import C1868SubCategories from '@/views/C1868SubCategories'
import C1868s from '@/views/C1868s'
import Products from '@/views/Products'
import Images from '@/views/Images'
import Photos from '@/views/Photos'
import PhotoImageCategories from '@/views/PhotoImageCategories'
import PhotoImages from '@/views/PhotoImages'
import Download from '@/views/Download'
import store from '../store.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home',
        requiresAuth: true
      }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        title: 'Help',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        requiresAuth: false
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      props: true,
      meta: {
        title: 'Search',
        requiresAuth: true
      }
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories,
      meta: {
        title: 'Categories',
        requiresAuth: true
      }
    },
    {
      path: '/branding-and-logos',
      name: 'BrandingAndLogos',
      component: BrandingAndLogos,
      meta: {
        title: 'BrandingAndLogos',
        requiresAuth: true
      }
    },
    {
      path: '/presentation-materials',
      name: 'PresentationMaterials',
      component: PresentationMaterials,
      meta: {
        title: 'PresentationMaterials',
        requiresAuth: true
      }
    },
    {
      path: '/category/:category_id/products',
      name: 'Products',
      component: Products,
      meta: {
        title: 'Products',
        requiresAuth: true
      }
    },
    {
      path: '/product/:product_id/images',
      name: 'Images',
      component: Images,
      meta: {
        title: 'Images',
        requiresAuth: true
      }
    },
    {
      path: '/photos',
      name: 'Photos',
      component: Photos,
      meta: {
        title: 'Photos',
        requiresAuth: true
      }
    },
    {
      path: '/photo/:photo_id/categories',
      name: 'PhotoImageCategories',
      component: PhotoImageCategories,
      meta: {
        title: 'Photo Image Categories',
        requiresAuth: true
      }
    },
    {
      path: '/photo/:photo_id/categories/:category_name/photo-images',
      name: 'PhotoImages',
      component: PhotoImages,
      meta: {
        title: 'Photo Images',
        requiresAuth: true
      }
    },
    {
      path: '/photo/:photo_id/photo-images',
      name: 'PhotoImages',
      component: PhotoImages,
      meta: {
        title: 'Photo Images',
        requiresAuth: true
      }
    },
    {
      path: '/ads',
      name: 'Advertisements',
      component: Advertisements,
      meta: {
        title: 'Advertisements',
        requiresAuth: true
      }
    },
    {
      path: '/sell-sheet-categories',
      name: 'SellSheetCategories',
      component: SellSheetCategories,
      meta: {
        title: 'Sell Sheets Categories',
        requiresAuth: true
      }
    },
    {
      path: '/category/:category_id/sell-sheets',
      name: 'SellSheets',
      component: SellSheets,
      meta: {
        title: 'Sell Sheets',
        requiresAuth: true
      }
    },
    {
      path: '/public-relations',
      name: 'PublicRelations',
      component: PublicRelations,
      meta: {
        title: 'Public Relations',
        requiresAuth: true
      }
    },
    {
      path: '/videos',
      name: 'Videos',
      component: Videos,
      meta: {
        title: 'Videos',
        requiresAuth: true
      }
    },
    {
      path: '/1868-categories',
      name: 'C1868Categories',
      component: C1868Categories,
      meta: {
        title: '1868 Cagtegories',
        requiresAuth: true
      }
    },
    {
      path: '/category/:category_id/sub-categories',
      name: 'C1868s',
      component: C1868SubCategories,
      meta: {
        title: '1868s',
        requiresAuth: true
      }
    },
    {
      path: '/category/:category_id/c1868s',
      name: 'C1868s',
      component: C1868s,
      meta: {
        title: '1868s',
        requiresAuth: true
      }
    },
    {
      path: '/category/:category_id/sub-categories/:sub_category_name/c1868s',
      name: 'C1868s',
      component: C1868s,
      meta: {
        title: '1868s',
        requiresAuth: true
      }
    },
    {
      path: '/download/:type/:id',
      name: 'Download',
      component: Download,
      meta: {
        title: 'Download',
        requiresAuth: true
      }
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js